<template>
  <reusable-window ref="reusable">
    <h3 class="text-center text-neon" style="margin-top: 0">{{ title }}</h3>
    <hr class="separador-horizontal" />
    <p style="font-size: 18px" v-html="message"></p>
    <div style="flex-direction: row; justify-content: space-between; text-align: center; min-width: 11.75dvw">
      <div class="row">
        <div class="col-md-12">
          <a class="btn btn-plain hover-neon main" @click="_confirm">{{ okButton }}</a>
        </div>
      </div>
    </div>
  </reusable-window>
</template>

<script>
import ReusableWindow from '@snippets/base/ReusableWindow.vue';

export default {
  name: 'PopupWindow',
  components: { ReusableWindow },
  data: () => ({
    title: undefined,
    message: undefined,
    okButton: undefined,
  }),
  methods: {
    show(options = {}) {
      this.title = options.title;
      this.message = options.message;
      this.okButton = options.okButton;
      return this.$refs.reusable.open();
    },
    _confirm() {
      this.$refs.reusable.close();
    },
  },
};
</script>
